import { render, staticRenderFns } from "./import_account.vue?vue&type=template&id=6c189f70&scoped=true&"
import script from "./import_account.vue?vue&type=script&lang=js&"
export * from "./import_account.vue?vue&type=script&lang=js&"
import style0 from "./import_account.vue?vue&type=style&index=0&id=6c189f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c189f70",
  null
  
)

export default component.exports